import { WppSkeleton } from '@wppopen/components-library-react'
import styles from './skeletonStyles.module.scss'

const AiOutputSkeleton = () => {
  return (
    <div className={styles.aiOutputSkeleton__container} data-testid="ai-output-skeleton">
      <div className={styles.aiOutputSkeleton__header}>
        <WppSkeleton height={32} width="60%" />
      </div>

      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div key={`skeleton-block-${index}`} className={styles.aiOutputSkeleton__block}>
            <div className={styles.aiOutputSkeleton__title}>
              <WppSkeleton height={24} width="40%" />
            </div>
            <div className={styles.aiOutputSkeleton__line}>
              <WppSkeleton height={16} width="100%" />
            </div>
            <div className={styles.aiOutputSkeleton__line}>
              <WppSkeleton height={16} width="90%" />
            </div>
            <div className={styles.aiOutputSkeleton__lineLarge}>
              <WppSkeleton height={16} width="95%" />
            </div>

            {index === 0 && (
              <>
                <div className={styles.aiOutputSkeleton__subtitle}>
                  <WppSkeleton height={20} width="30%" />
                </div>
                <div className={styles.aiOutputSkeleton__line}>
                  <WppSkeleton height={16} width="85%" />
                </div>
                <div className={styles.aiOutputSkeleton__lineLarge}>
                  <WppSkeleton height={16} width="80%" />
                </div>
              </>
            )}
          </div>
        ))}
    </div>
  )
}

export default AiOutputSkeleton
